import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
  reduxForm,
} from 'redux-form';
import {
  Badge,
  Col,
  Container,
  Row,
  Popover,
  PopoverHeader,
  PopoverBody,
} from 'reactstrap';
import setPropsAsInitialValues from '../../helpers/setPropsAsInitialValues';
import DataTable from '../../shared/components/DataTable';
import TooltipItem from '../../shared/components/TooltipItem';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import {
  fetch,
  updatePresenceStundent,
  fetchAll,
  fetchFormDatas,
  deleteAssistance,
} from '../../redux/actions/assistanceActions';
import Confirm from '../../shared/components/Confirm';
import {
  dateFormat,
  dateMMFormat,
  dateDDFormat,
  dateTimeFormat,
} from '../../helpers/dateFormat';
import {
  createErrorMessage, createSuccessMessage, createWarningMessage,
} from '../../helpers/notification';
import AssistanceForm from './Form';
import AssistanceFormModal from './Form/formModal';

const AssistValues = [
  {
    value: null, label: '​➖', description: '-', color: 'secondary',
  },
  {
    value: true, label: '✔️', description: 'Presente', color: 'success',
  },
  {
    value: false, label: '​❌', description: 'Ausente', color: 'danger',
  },
];

function OwnerPopover({
  assistanceId,
  date,
  canEdit,
  reference,
  onGetAssistance,
  onGetCurrentStudent,
  onNextPage,
  onPreviousPage,
  onPresent,
  onAbsent,
  onClose,
}) {
  if (!canEdit) {
    return null;
  }

  const [open, setOpen] = React.useState(false);
  const [assistance, setAssistance] = React.useState(false);
  const toggle = () => setOpen(!open);
  return (
    <div>
      <button
        id={`popover${assistanceId}`}
        type="button"
        onClick={toggle}
        className="action-button"
      >
        <span key={`span${assistanceId}`} className="fa fa-edit" title="Editar" />
      </button>
      <Popover flip="true" target={`popover${assistanceId}`} isOpen={open}>
        <PopoverHeader>
          <div
            className="table"
            style={{
              margin: '0',
              display: 'flex',
              alignItems: 'baseline',
              justifyContent: 'space-between',
              columnGap: '1rem',
            }}
          >
            <div>
              {`#${assistanceId}, ${dateFormat(date)}, Ref:`}
              {
                <span style={{ fontWeight: 'bold' }}>{reference || ''}</span>
              }
            </div>
            <button
              type="button"
              className="action-button"
              onClick={() => {
                setOpen(false);
                setAssistance(false);
                onClose();
              }}
            >
              <span className="fa fa-times" title="Cerrar" />
            </button>
          </div>
        </PopoverHeader>
        <PopoverBody>
          <table className="table" style={{ marginBottom: '0' }}>
            <thead>
              {
                onGetCurrentStudent({
                  assistance,
                  assistanceId,
                  date,
                  reference,
                  setAssistance,
                  onGetAssistance,
                  onPreviousPage,
                  onNextPage,
                  onPresent,
                  onAbsent,
                })
              }
            </thead>
          </table>
        </PopoverBody>
      </Popover>
    </div>
  );
}

OwnerPopover.propTypes = {
  assistanceId: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  canEdit: PropTypes.bool.isRequired,
  reference: PropTypes.string.isRequired,
  onGetAssistance: PropTypes.func.isRequired,
  onGetCurrentStudent: PropTypes.func.isRequired,
  onNextPage: PropTypes.func.isRequired,
  onPreviousPage: PropTypes.func.isRequired,
  onPresent: PropTypes.func.isRequired,
  onAbsent: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

class AssistanceContainer extends PureComponent {
  static propTypes = {
    subjectPeriodId: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      loadingAssists: false,
      items: [],
      assists: [],
      studentAssists: [],
      filters: { id: 10 },
      showForm: false,
      showFormModal: false,
      logContents: [],
      endHomework: '',
      canEdit: false,
      editAssistance: false,
      id: 0,
      students: [],
      currentStudentId: 0,
    };

    this.columns = ({
      assists, studentAssists, canEditTask, editAssistance,
    }) => {
      const cols = [
        {
          key: 'doc',
          name: 'Nº doc',
          width: '100px',
          search: true,
        },
        {
          key: 'surname',
          name: 'Apellido',
          visible: false,
          search: true,
        },
        {
          key: 'name',
          name: 'Nombre',
          search: true,
          width: '300px',
          format: ({ surname, name }) => (
            <span style={{ display: 'flex', width: '220px' }}>
              {`${surname}, ${name}`.trim()}
            </span>
          ),
        },
      ];

      const groupByAssistance = assists.map(({ id, date, reference }) => ({ assistanceId: id, date, reference }));

      const assistanceByStudents = studentAssists
        .map(({ assistanceId, studentId, present }) => ({ assistanceId, studentId, present }));
      const assistanceLength = groupByAssistance.length;
      const attendancePerc = [];

      studentAssists
        .map(({ studentId, present }) => ({ studentId, present }))
        .reduce((res, { studentId, present }) => {
          if (!res[studentId]) {
            res[studentId] = { studentId, ok: 0 };
            attendancePerc.push(res[studentId]);
          }

          res[studentId].ok += present ? 1 : 0;

          return res;
        }, {});

      const assistanceHeaders = groupByAssistance.map(a => ({
        key: `assistance${a.assistanceId}`,
        name: (
          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
            <div>{dateDDFormat(a.date)}</div>
            <TooltipItem
              key={`tti-id-${a.assistanceId}`}
              id={`${a.assistanceId}`}
              value={dateMMFormat(a.date)}
              label={a.reference || ''}
              color="secondary"
            />
            <div
              key={`btn${a.assistanceId}`}
              type="button"
              className="action-button"
            >
              <OwnerPopover
                assistanceId={a.assistanceId}
                date={a.date}
                reference={a.reference || ''}
                canEdit={canEditTask}
                onGetAssistance={this.getAssistance}
                onGetCurrentStudent={this.getCurrentStudent}
                onNextPage={this.nextPage}
                onPreviousPage={this.previousPage}
                onPresent={this.handlePresent}
                onAbsent={this.handleAbsent}
                onClose={this.refreshTable}
              />
            </div>
          </div>
        ),
        width: '75px',
        className: 'text-center',
        format: ({ studentId }) => {
          const assistanceByStudent = assistanceByStudents
            .find(as => as.assistanceId === a.assistanceId && as.studentId === studentId);

          if (!assistanceByStudent || assistanceByStudent.present === null) {
            return <span role="img" aria-label="Sin Asistencia">​➖</span>;
          }

          if (assistanceByStudent.present === false) {
            return (
              <span role="img" aria-label="Ausente">​❌</span>
            );
          }

          return (
            <span role="img" aria-label="Presente">✔️</span>
          );
        },
      }));

      return [
        ...cols,
        ...[
          {
            key: 'assistPerc',
            name: '% Asistencia',
            editable: false,
            width: '110px',
            className: 'text-center',
            inputStyle: () => this.inputStyle,
            format: ({ studentId: id, assistPerc = 0 }) => {
              if (editAssistance) {
                return (
                  <Badge
                    color="primary"
                    pill
                    style={{
                      textAlign: 'center',
                      fontWeight: 'normal',
                      fontSize: '100%',
                    }}
                  >
                    {assistPerc}
                  </Badge>
                );
              }

              return (
                <Badge
                  color="primary"
                  pill
                  style={{
                    textAlign: 'center',
                    fontWeight: 'normal',
                    fontSize: '100%',
                  }}
                >
                  {
                    attendancePerc.filter(({ studentId }) => id === studentId)
                      .map(({ ok }) => Math.round((ok / assistanceLength) * 100))[0]
                    || assistPerc
                  }
                </Badge>
              );
            },
          },
        ],
        ...assistanceHeaders,
      ];
    };
  }

  componentDidMount() {
    this.refreshTable();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      page, pageSize, totalItemsCount, filters,
    } = this.state;
    const state = { filters };

    // Typical usage (don't forget to compare props):
    if (page !== prevState.page) {
      state.page = page;
    }

    if (pageSize !== prevState.pageSize) {
      state.pageSize = pageSize;
    }

    if (totalItemsCount !== prevState.totalItemsCount) {
      state.totalItemsCount = totalItemsCount;
    }
  }

  handlePresent = ({ assistanceId, studentId }) => {
    if (!assistanceId || !studentId) {
      return;
    }

    this.setState({ loadingAssists: true });

    const { students } = this.state;

    updatePresenceStundent({
      assistanceId,
      payload: {
        assistanceId, studentId, present: true,
      },
      onSuccess: ({ payload = {} }) => {
        createSuccessMessage('Asistencia tomada éxitosamente');

        const newArray = [...students];
        const index = newArray.findIndex(item => item.studentId === studentId);

        newArray[index] = {
          ...newArray[index],
          present: payload.present || false,
        };

        this.setState({
          students: newArray,
          loadingAssists: false,
        });

        this.nextPage();
      },
      onError: (error) => {
        this.setState({
          loadingAssists: false,
        });

        if (error && error.status === 404) {
          createWarningMessage('La asistencia no existe');
          return;
        }

        createErrorMessage('Error al intentar cargar los datos de la asistencia');
      },
    });
  }

  handleAbsent = ({ assistanceId, studentId }) => {
    if (!assistanceId || !studentId) {
      return;
    }

    this.setState({ loadingAssists: true });

    const { students } = this.state;

    updatePresenceStundent({
      assistanceId,
      payload: {
        assistanceId, studentId, present: false,
      },
      onSuccess: ({ present }) => {
        createSuccessMessage('Asistencia tomada éxitosamente');

        const newArray = [...students];
        const index = newArray.findIndex(item => item.studentId === studentId);

        newArray[index] = {
          ...newArray[index],
          present,
        };

        this.setState({
          students: newArray,
          loadingAssists: false,
        });

        this.nextPage();
      },
      onError: (error) => {
        this.setState({
          loadingAssists: false,
        });

        if (error && error.status === 404) {
          createWarningMessage('La asistencia no existe');
          return;
        }

        createErrorMessage('Error al intentar cargar los datos de la asistencia');
      },
    });
  }

  getAssistance = ({ id }) => {
    if (!id) {
      this.setState({
        students: [],
        loading: false,
        currentStudentId: 0,
      });

      return;
    }

    fetch({
      id,
      onSuccess: ({
        students = [],
      }) => {
        this.setState({
          students,
          loading: false,
          currentStudentId: 0,
        });
        if (students.length) {
          this.nextPage();
          return;
        }

        createWarningMessage('La asistencia no tiene alumnos');
      },
      onError: (error) => {
        this.setState({
          students: [],
          loading: false,
          currentStudentId: 0,
        });

        if (error && error.status === 404) {
          createWarningMessage('La asistencia no existe');
          return;
        }

        createErrorMessage('Error al intentar cargar los datos de la asistencia');
      },
    });
  }

  refreshTable = (criteria = {}) => {
    const {
      page = 1, pageSize = 25, totalItemsCount = 0, filters = {},
    } = criteria;

    const state = {
      filters: filters || { logContent: [] },
      page,
      pageSize,
      totalItemsCount,
    };

    this.refreshFormDatas();

    this.fetchTable({ ...state });
  }

  refreshFormDatas = () => {
    const { subjectPeriodId } = this.props;

    this.setState({ loading: true });
    fetchFormDatas({
      subjectPeriodId,
      onSuccess: ({
        logContents,
        endHomework,
        canEdit,
        editAssistance,
      }) => this.setState({
        loading: false,
        logContents,
        endHomework,
        canEdit,
        editAssistance,
      }),
      onError: () => {
        this.setState({
          loading: false,
          logContents: [],
          endHomework: '',
          canEdit: false,
          editAssistance: false,
        });
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  fetchTable = ({ page, pageSize, filters }) => {
    const {
      subjectPeriodId,
    } = this.props;

    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });

    fetchAll({
      subjectPeriodId,
      pageInfo: {
        page,
        pageSize,
        filters,
      },
      onSuccess: ({ pageInfo, assists, studentAssists }) => {
        const { items, totalItemsCount } = pageInfo;
        this.setState({
          loading: false,
          items,
          totalItemsCount,
          assists,
          studentAssists,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de materias por periodo');
      },
    });
  }

  handleDeleteAction = (record) => {
    const { page, pageSize } = this.state;
    this.refreshTable({ page, pageSize });

    const name = `#${record.id}, ${dateFormat(record.date)}, Ref:${record.reference || ''}`;
    Confirm({
      title: 'Borrar asistencia',
      question: `Estás seguro que deseas eliminar esta asistencia "${name}"?`,
      yesLabel: 'Si, Borrar',
      noLabel: 'No, Volver',
      onConfirm: () => {
        deleteAssistance(record.id, {
          onSuccess: () => {
            createSuccessMessage('Asistencia borrada exitosamente');
            this.refreshTable({ page, pageSize });
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('La asistencia no existe');
            } else {
              createErrorMessage('Error al intentar borrar asistencia');
            }
          },
        });
      },
    });
  };

  handleHideForm = () => {
    this.setState({
      showForm: false,
      showFormModal: false,
    });

    this.refreshTable();
  };

  editAssistance = ({ id = 0 }) => {
    this.refreshFormDatas();
    if (id === 0) {
      this.setState({
        id, showFormModal: true, showForm: false,
      });

      return;
    }

    this.setState({
      id, showForm: true, showFormModal: false,
    });
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.refreshTable({ page, pageSize, filters });
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.refreshTable({ page: 1, pageSize, filters: values });
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize, filters } = this.state;
    const { autoHideSearch } = filters;
    this.refreshTable({ page: 1, pageSize, filters: { autoHideSearch } });
  };

  nextPage = () => {
    const { students = [], currentStudentId } = this.state;

    const index = students.findIndex(s => s.studentId === currentStudentId);
    const newIndex = index + 1 === students.length ? 0 : index + 1;

    const student = students[newIndex];

    this.setState({ currentStudentId: student.studentId });
  };

  previousPage = () => {
    const { students = [], currentStudentId } = this.state;

    const index = students.findIndex(s => s.studentId === currentStudentId);
    const { studentId } = students[index === 0 ? students.length - 1 : index - 1];

    this.setState({ currentStudentId: studentId });
  };

  getCurrentStudent = ({
    assistance,
    assistanceId,
    date,
    reference,
    setAssistance,
    onGetAssistance,
    onPreviousPage,
    onNextPage,
    onPresent,
    onAbsent,
  }) => {
    const { students = [], currentStudentId } = this.state;
    const studentIndex = students.findIndex(s => s.studentId === currentStudentId);

    if (!assistance) {
      return (
        <tr>
          <th>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: '1rem',
              alignItems: 'center',
            }}
            >
              <div>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    setAssistance(true);
                    onGetAssistance({ id: assistanceId });
                  }}
                  style={{ marginBottom: '0' }}
                >
                  <i className="fa fa-hand-paper-o" /> Tomar asistencia
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    this.editAssistance({ id: assistanceId });
                  }}
                  style={{ marginBottom: '0' }}
                >
                  <i className="fa fa-edit" /> Editar asistencia
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => {
                    this.handleDeleteAction({
                      id: assistanceId,
                      date,
                      reference,
                    });
                  }}
                  style={{ marginBottom: '0' }}
                >
                  <i className="fa fa-trash" /> Borrar asistencia
                </button>
              </div>
            </div>
          </th>
        </tr>
      );
    }
    if (studentIndex === -1) {
      return <></>;
    }

    const {
      doc, name, surname, present = false,
    } = students[studentIndex];

    const [assistanceValue] = AssistValues.filter(a => a.value === present);

    return (
      <>
        <tr>
          <th>
            <div>Nº documento: {doc}</div>
            <div>{surname}</div>
            <div>{name}</div>
          </th>
        </tr>
        <tr>
          {
            this.assistanceButtons({
              assistanceId,
              currentStudentId,
              assistanceValue,
              onPreviousPage,
              onNextPage,
              onPresent,
              onAbsent,
              pointerStudent: `${studentIndex + 1}/${students.length}`,
            })
          }
        </tr>
      </>
    );
  }

  assistanceButtons = ({
    assistanceId,
    currentStudentId,
    assistanceValue,
    onPreviousPage,
    onNextPage,
    onPresent,
    onAbsent,
    pointerStudent,
  }) => {
    const { loadingAssists } = this.state;
    if (loadingAssists) {
      return <LoadingSpinner />;
    }

    return (
      <th>
        <div
          className="form__form-group-field"
          style={{ columnGap: '0.5rem', justifyContent: 'space-between' }}
        >
          <button
            key={`button-arrow-left-${assistanceId}-${currentStudentId}`}
            type="button"
            className="action-button"
            onClick={onPreviousPage}
          >
            <span
              key={`span-arrow-left${assistanceId}-${currentStudentId}`}
              title="Anterior"
              className="fa fa-arrow-circle-left fa-2x"
            />
          </button>
          <div style={{ display: 'grid', fontSize: '1.1rem', justifyItems: 'center' }}>
            <div>{pointerStudent}</div>
            <span
              className={`badge badge-${assistanceValue.color}`}
              style={{ textAlign: 'center' }}
            >
              {assistanceValue.description}
            </span>
            <div>
              <button
                key={`button-ok-${assistanceId}-${currentStudentId}`}
                type="button"
                className="action-button"
                onClick={() => onPresent({ assistanceId, studentId: currentStudentId })}
              >
                <span
                  key={`span-ok-${assistanceId}-${currentStudentId}`}
                  title="Presente"
                  className="fa fa-check fa-2x"
                />
              </button>
              <button
                key={`button-no-${assistanceId}-${currentStudentId}`}
                type="button"
                className="action-button"
                onClick={() => onAbsent({ assistanceId, studentId: currentStudentId })}
              >
                <span
                  key={`span-no-${assistanceId}-${currentStudentId}`}
                  title="Ausente"
                  className="fa fa-times fa-2x"
                />
              </button>
            </div>
          </div>
          <button
            key={`button-arrow-right-${assistanceId}-${currentStudentId}`}
            type="button"
            className="action-button"
            onClick={onNextPage}
          >
            <span
              key={`span-arrow-right-${assistanceId}-${currentStudentId}`}
              title="Anterior"
              className="fa fa-arrow-circle-right fa-2x"
            />
          </button>
        </div>
      </th>
    );
  };

  addButton = () => {
    const {
      showForm, showFormModal, endHomework, canEdit,
    } = this.state;

    if (showForm || showFormModal) {
      return null;
    }

    if (!canEdit && endHomework) {
      return (
        <Col md={10} lx={12}>
          <div className="card__title">
            <h4>
              <Badge color="warning">
                Fecha L&iacute;mite Calificar Tareas Y Tomar Asistencias {dateTimeFormat(endHomework)}
              </Badge>
            </h4>
          </div>
        </Col>
      );
    }

    return (
      <Row>
        <Col md={12} style={{ marginBottom: '10px', marginTop: '10px' }}>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            style={{ marginBottom: '0' }}
            onClick={() => this.editAssistance({ id: 0 })}
          >
            <i className="fa fa-plus" /> Agregar Nueva Asistencia
          </button>
        </Col>
      </Row>
    );
  };

  studentAssistanceForm = () => {
    const {
      id, logContents, endHomework, showForm, canEdit,
    } = this.state;

    const { subjectPeriodId } = this.props;
    if (!subjectPeriodId || !showForm) {
      return null;
    }
    return (
      <Row>
        <AssistanceForm
          id={id}
          subjectPeriodId={subjectPeriodId}
          logContents={logContents}
          endHomework={endHomework}
          canEdit={canEdit}
          onHideForm={this.handleHideForm}
          enableReinitialize
        />
      </Row>
    );
  };

  studentAssistanceFormModal = () => {
    const {
      id, logContents, showFormModal,
    } = this.state;

    const { subjectPeriodId } = this.props;
    if (!subjectPeriodId || !showFormModal) {
      return null;
    }
    const show = false;
    if (show) {
      AssistanceFormModal({
        title: <b>Nueva Asistencia</b>,
        id,
        subjectPeriodId,
        logContents,
        onHideForm: this.handleHideForm,
        color: 'primary',
        onValueChanges: (key, value) => {
          console.log(key, value);
          const { currentInscription } = this.state;
          this.setState({ currentInscription: { ...currentInscription, [key]: +value } });
        },
        onConfirm: (value) => {
          console.log(value);
        },
      });

      return null;
    }

    return (
      <Row>
        <AssistanceForm
          id={id}
          subjectPeriodId={subjectPeriodId}
          logContents={logContents}
          onHideForm={this.handleHideForm}
          enableReinitialize
        />
      </Row>
    );
  };

  dataTable = () => {
    const {
      showForm,
      showFormModal,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
      assists,
      studentAssists,
      canEdit,
      editAssistance,
    } = this.state;

    if (showForm || showFormModal) {
      return null;
    }

    return (
      <Row>
        <DataTable
          key="tblAssists"
          title="Listado de todas las asistencias"
          columns={this.columns({
            assists, studentAssists, canEditTask: canEdit, editAssistance,
          })}
          items={items}
          onChangePage={this.onChangePage}
          totalItemsCount={totalItemsCount}
          onSubmit={this.onDataTableSubmit}
          onClearFilters={this.onDataTableClearFilters}
          // getGridActions={(key, row) => this.getGridActions(key, row)}
          itemsToShow={items.length}
          page={page}
          pageSize={pageSize}
          autoHideSearch={filters.autoHideSearch}
          initialValues={filters}
          enableReinitialize
        />
      </Row>
    );
  };

  render() {
    const {
      loading,
    } = this.state;

    if (loading) {
      return <LoadingSpinner />;
    }

    return (
      <Container>
        {this.addButton()}
        {this.studentAssistanceForm()}
        {this.studentAssistanceFormModal()}
        {this.dataTable()}
      </Container>
    );
  }
}

const ReduxAssistanceContainer = reduxForm({
  form: 'AssistanceContainer',
  enableReinitialize: true,
})(AssistanceContainer);

export default setPropsAsInitialValues(ReduxAssistanceContainer);
